import { createModal } from '/@/core/elements/modal'

const { api, component } = createModal(
  'DesignerKudosModal',
  () => import('./DesignerKudosModal.vue'),
)

export const useDesignerKudosModal = api
export default component
